import ApiBlur, { BlurType, BLUR_TYPES } from "../api/model/snapshots/layers/Blur";
import { VariableReference } from "../api/model/variables/Variables";

import Model from "./model";

export default class Blur extends Model {
    #type: BlurType;
    #radius: number;
    #variableReferences?: VariableReference[];

    constructor({
        type,
        radius,
        variableReferences
    }: ApiBlur) {
        super();

        this.#type = type;
        this.#radius = radius;
        this.#variableReferences = variableReferences;
    }

    get type(): BlurType {
        return this.#type;
    }

    set type(value: BlurType) {
        if (BLUR_TYPES.indexOf(value) === -1) {
            throw new TypeError(`Unknown blur type: '${value}'. Possible values: ${JSON.stringify(BLUR_TYPES)}`);
        }

        this.#type = value;
    }

    get radius(): number {
        return this.#radius;
    }

    set radius(value: number) {
        if (value < 0) {
            throw new RangeError(`Invalid radius value: '${value}'. Valid range: [0, ∞)`);
        }

        this.#radius = value;
    }

    get variableReferences() : VariableReference[] | undefined {
        return this.#variableReferences;
    }

    set variableReferences(variableReferences: VariableReference[] | undefined) {
        this.#variableReferences = variableReferences;
    }

    override toObject(): ApiBlur {
        return {
            type: this.#type,
            radius: this.#radius,
            variableReferences: this.#variableReferences
        };
    }
}
